module.exports = __webpack_public_path__ + "static/media/N1.b160e3de.jpg";